#!/usr/bin/env node
import { BrainSam } from './main'

let data:any[] = []
new BrainSam(data);